/**
 * Générateur — Attendu 189 — O7 « Il mobilise les connaissances des figures, des
 * configurations et de la translation pour déterminer des grandeurs
 * géométriques. »
 * Niveau : 4ème | Thème #11 Géométrie plane (O7) | Espace et géométrie.
 *
 * ── REVUE 2026-09-24 au soir (retour du prof sur la vague 4) ──────────────
 * « Tu as mélangé du Thalès et du Pythagore dans 189 » : 189 devient la
 * TRANSLATION. Plafond : Eduscol fin de 4e (2019) l. 404-405 (la ligne
 * elle-même) ; son exemple exact est dans la partie des transformations,
 * l. 352-353 : « Il détermine des longueurs, des aires et des mesures
 * d'angles en utilisant les propriétés de conservation de la translation »
 * (l. 338-340 : conservation du parallélisme, des longueurs, des aires et
 * des angles). Eduscol illustre aussi la ligne par Pythagore et le cosinus
 * (l. 416-427, l'échelle de 13 m) : ces calculs vivent dans les automatismes
 * 1088 (Pythagore, qui reçoit « Le bon triangle » et « Deux triangles »,
 * venues d'ici) et 1090 (le cosinus). Exercices du prof pour cet attendu :
 * la figure verte et son image orange (ex. 1 « ED = 1,5 cm donc E'D' = … » ;
 * ex. 2 « Aire RSTU = 4 cm² donc Aire R'S'T'U' = … » ; ex. 3 RAMI → BELO :
 * le tableau des images, [BE], l'angle BEL, « écris deux autres égalités de
 * mesure d'angle »).
 *
 * ── Revue 2026-09-25 (décisions prof, épreuve de Musk) ───────────────────
 * 1. « L'image d'un sommet » (sommet_qcm_unique) DÉPLACÉE vers 187 : « quelle
 *    est l'image du point B ? » ne détermine ni longueur, ni aire, ni angle,
 *    elle ne sert aucune ligne du plafond de 189 ; c'est lire la
 *    correspondance d'une figure et de son image (ex. 3 a du prof), donc
 *    « transformer une figure », la ligne de 187, où aucune carte ne le
 *    demandait (images en primes ou flèche de A vers B). Le tirage de la
 *    figure nommée (tirerImage, phraseImage, figureImage) vit désormais dans
 *    figTranslation.js, partagé. L'erreur correspondance_par_les_noms reste
 *    mesurée ici par les deux formats qui lisent la figure ; les questions
 *    déjà en banque sous 189 gardent leur contenu.
 * 2. Les trois cartes de la translation FUSIONNÉES en une seule, « La figure
 *    image », à trois formats : elles servent la même ligne (l. 352).
 * 3. 189 devient une ÉTAGÈRE : l'attendu, c'est le moment où l'élève doit
 *    trouver LUI-MÊME l'outil (Pythagore, cosinus, Thalès, la translation).
 *    Donc, en plus de sa carte, 189 réexporte les cartes des automatismes
 *    dont l'énoncé ne nomme aucun théorème et qui demandent un choix (quel
 *    triangle, quelle étape d'abord, quel outil) ; les cartes d'un seul geste
 *    restent dans leurs automatismes. Mécanisme de gen_1058 : le payload est
 *    re-badgé 189 (obligatoire, le composeur filtre par attendu), la clé est
 *    préfixée par l'outil (1088 et 1090 ont toutes deux echelle_texte), le
 *    nom de carte vit dans _meta (jamais dans la question enregistrée :
 *    l'élève ne voit que l'énoncé), la calculatrice suit la carte (contenu).
 *    Solveurs : tests/solvers/index.js renvoie vers ceux des sources. Une
 *    carte composée depuis 189 compte pour 189, depuis 1088 pour 1088
 *    (précédent 1058, accepté le 09/09).
 *
 * ── Cartes ────────────────────────────────────────────────────────────────
 *   « La figure image » (la carte de 189, trois formats) :
 *     QCM (image_qcm_unique) : la longueur d'un côté ou la mesure d'un angle
 *       de l'image, lue sur le côté ou l'angle qui lui correspond (ex. 3 b
 *       et d). Le QCM de l'attendu.
 *     Vrai / Faux (egalites_vrai_faux) : quatre égalités de longueurs ou
 *       d'angles entre l'image et la figure de départ (ex. 3 c et e), de une
 *       à trois vraies ; toutes les mesures de la figure de départ sont
 *       écrites et toutes différentes, donc une égalité fausse l'est pour de
 *       bon.
 *     Saisie (aire_texte) : un rectangle, un carré ou un triangle rectangle
 *       avec ses dimensions, son image sans aucune mesure ; l'aire ou le
 *       périmètre de l'image (ex. 2 a).
 *     Les noms de l'image (QCM et Vrai / Faux) : d'autres lettres, lues dans
 *     un sens ou dans l'autre à partir d'un autre sommet, comme RAMI → BELO.
 *     Sur la saisie, des primes (ex. 1 et 2 du prof). Ni calculatrice ni
 *     rappel brouillon : on lit une correspondance, et les seuls calculs sont
 *     des aires et des périmètres de nombres simples.
 *   L'ÉTAGÈRE (cartes importées, voir ETAGERE) :
 *     « L'échelle : la hauteur » (pythagore_echelle_texte, 1088) : l'exemple
 *       Eduscol l. 416, un contexte, rien ne dit Pythagore.
 *     « Deux triangles » (pythagore_deux_triangles_texte, 1088) : deux
 *       étapes au brouillon, une seule réponse (fiche 7 du prof).
 *     « L'échelle : l'angle » (cosinus_echelle_texte, 1090) : l'exemple
 *       Eduscol l. 420, l'angle de 67°.
 *     « Triangles emboîtés » (thales_calcul_texte, 1086) : Thalès n'a pas de
 *       carte complexe ; sans elle l'élève n'aurait jamais à reconnaître une
 *       configuration de Thalès parmi les autres.
 *     Écartées : les cartes d'un seul geste (« Calcule la longueur » de 1088,
 *     « Calculer un angle / une longueur » de 1090 : l'échelle les
 *     représente), « Le bon triangle » (ne finit pas par un nombre), et tout
 *     ce qui nomme ou découpe l'outil (« Quel calcul ? », « Écrire le
 *     cosinus », « L'égalité de Thalès », « Les étapes »).
 *
 * ── Erreurs (familles nommées) ───────────────────────────────────────────
 *   correspondance_par_les_noms (PRINCIPALE) : la mesure ou le côté qui a la
 *     même place dans les deux noms ;
 *   autre_mesure ; on_ne_peut_pas_savoir (la conservation
 *   ignorée) ; aire_avec_hypotenuse (le triangle rectangle : l'hypoténuse
 *   prise pour une hauteur, nommée pour la fiche : la carte est une saisie).
 *
 * SACRIFIÉS (fiches à venir) : les données de RAMI du prof (3 cm, 4,2 cm,
 * 83°, 52°), hors de portée des quadrilatères tirés ; le rectangle de 6 cm
 * sur 4 cm, jamais tiré.
 */

import {
    randInt, randomChoice, shuffle, pickLettresSains, tex,
    makeQcm, makeSaisie, makeVraiFaux,
} from '../../../utils';
import { imgElement } from '../../5eme/statistiques/svgStats';
import { tourner } from '../../3eme/geometrie-plane/figTriangle';
import { vecteurCoteACote, svgTranslation, tirerImage, phraseImage, figureImage, POOL_LETTRES } from './figTranslation';
import { generate as genererThales } from './gen_1086';
import { generate as genererPythagore } from './gen_1088';
import { generate as genererCosinus } from './gen_1090';

const ATTENDU_ID = 189;
const opts = (label) => ({ niveau: '4eme', matiere: 'maths', attendu: ATTENDU_ID, label });

const L_IMAGE = 'La figure image';

const NE_PEUT_PAS = 'On ne peut pas le savoir.';
const fr = (x) => String(x).replace('.', ',');
const frDix = (d) => (d % 10 === 0 ? String(d / 10) : `${Math.trunc(d / 10)},${d % 10}`);

// La figure nommée et son image (tirerImage, phraseImage, figureImage) vivent
// dans figTranslation.js depuis le 2026-09-25 : partagées avec 187
// « L'image d'un sommet ».

// ─── Format QCM de « La figure image » : une longueur ou un angle ──────────

const genImage = () => {
    for (let essai = 0; essai < 100; essai++) {
        const t = tirerImage();
        const surLongueur = randInt(0, 1) === 0;
        let question; let bon; let piege; let autre; let cotes = []; let angles = [];
        if (surLongueur) {
            // un côté de l'image [X Y] (lettres voisines du nom de l'image) dont la lecture « dans l'ordre des noms » tombe sur un AUTRE côté
            const j = randInt(0, 3);
            const a = t.ordreImage[j]; const b = t.ordreImage[(j + 1) % 4];
            const vrai = (a + 1) % 4 === b ? a : b;                            // le côté du départ (côté i = [sommet i, sommet i + 1])
            const lu = j;                                                      // la lecture dans l'ordre des noms : [noms[j], noms[j + 1]]
            if (lu === vrai) continue;
            const reste = [0, 1, 2, 3].filter((i) => i !== vrai && i !== lu);
            const troisieme = randomChoice(reste);
            cotes = shuffle([vrai, lu, troisieme]).map((i) => ({ i, texte: `${frDix(t.cotes[i])} cm` }));
            question = `Quelle est la longueur du segment ${tex(`[${t.nomsImage[a]}${t.nomsImage[b]}]`)} ?`;
            bon = `${frDix(t.cotes[vrai])} cm`; piege = `${frDix(t.cotes[lu])} cm`; autre = `${frDix(t.cotes[troisieme])} cm`;
        } else {
            const j = randInt(0, 3);
            const s = t.ordreImage[j];
            if (s === j) continue;                                             // la lecture dans l'ordre tomberait juste
            const troisieme = randomChoice([0, 1, 2, 3].filter((i) => i !== s && i !== j));
            angles = shuffle([s, j, troisieme]).map((i) => ({ i, texte: `${t.angles[i]}°` }));
            const avant = t.nomsImage[t.ordreImage[(j + 3) % 4]]; const apres = t.nomsImage[t.ordreImage[(j + 1) % 4]];
            question = `Quelle est la mesure de l'angle ${tex(`\\widehat{${avant}${t.nomsImage[s]}${apres}}`)} ?`;
            bon = `${t.angles[s]}°`; piege = `${t.angles[j]}°`; autre = `${t.angles[troisieme]}°`;
        }
        const texte = `${phraseImage(t)}<p><b>${question}</b></p>`;
        const payload = makeQcm([bon, piege, autre, NE_PEUT_PAS], bon, texte, { ...opts(L_IMAGE), elements_additionnels: figureImage(t, cotes, angles) });
        payload._meta.params = {
            surLongueur, nom: t.nom, nomImage: t.nomImage,
            distracteurs: [{ code: 'correspondance_par_les_noms' }, { code: 'autre_mesure' }, { code: 'on_ne_peut_pas_savoir' }],
        };
        return payload;
    }
    throw new Error('gen_189 : figure image sans question');
};

// ─── Format Vrai / Faux de « La figure image » : les égalités ──────────────

/**
 * Une ligne par élément de l'image (ses quatre côtés, ou ses quatre angles) :
 * vraie, elle l'égale à l'élément qui lui correspond ; fausse, à celui qui a
 * la même place dans le nom de la figure de départ (le piège), ou à un autre
 * quand les deux se confondent. L'élément de l'image est écrit à gauche ou à
 * droite du signe =.
 */
const genEgalites = () => {
    const t = tirerImage();
    const surLongueurs = randInt(0, 1) === 0;
    const vraies = new Set(shuffle([0, 1, 2, 3]).slice(0, randInt(1, 3)));
    const n = (i) => t.noms[(i + 4) % 4];
    const lignes = []; const verites = []; const codes = [];
    shuffle([0, 1, 2, 3]).forEach((j) => {
        const vrai = vraies.has(j);
        const o = (d) => t.ordreImage[(j + d + 4) % 4];                     // le sommet de départ à la place j + d du nom de l'image
        let gauche; let droite; let code = null;
        if (surLongueurs) {
            gauche = `${t.nomImage[j]}${t.nomImage[(j + 1) % 4]}`;
            const correspondant = (o(0) + 1) % 4 === o(1) ? o(0) : o(1);      // l'indice du côté de départ qui lui correspond
            if (vrai) droite = `${n(o(0))}${n(o(1))}`;
            else if (correspondant !== j) { droite = `${n(j)}${n(j + 1)}`; code = 'correspondance_par_les_noms'; }
            else { const i = randomChoice([0, 1, 2, 3].filter((x) => x !== correspondant)); droite = `${n(i)}${n(i + 1)}`; code = 'autre_mesure'; }
        } else {
            gauche = `\\widehat{${t.nomImage[(j + 3) % 4]}${t.nomImage[j]}${t.nomImage[(j + 1) % 4]}}`;
            if (vrai) droite = `\\widehat{${n(o(-1))}${n(o(0))}${n(o(1))}}`;
            else if (o(0) !== j) { droite = `\\widehat{${n(j - 1)}${n(j)}${n(j + 1)}}`; code = 'correspondance_par_les_noms'; }
            else { const i = randomChoice([0, 1, 2, 3].filter((x) => x !== o(0))); droite = `\\widehat{${n(i - 1)}${n(i)}${n(i + 1)}}`; code = 'autre_mesure'; }
        }
        lignes.push(tex(randInt(0, 1) === 0 ? `${gauche} = ${droite}` : `${droite} = ${gauche}`));
        verites.push(vrai); codes.push(code);
    });
    const cotes = surLongueurs ? [0, 1, 2, 3].map((i) => ({ i, texte: `${frDix(t.cotes[i])} cm` })) : [];
    const angles = surLongueurs ? [] : [0, 1, 2, 3].map((i) => ({ i, texte: `${t.angles[i]}°` }));
    const texte = `${phraseImage(t)}<p><b>Vrai ou faux ?</b></p>`;
    const payload = makeVraiFaux(lignes, verites.map((v) => (v ? 0 : 1)), texte, { ...opts(L_IMAGE), elements_additionnels: figureImage(t, cotes, angles) });
    payload._meta.params = { surLongueurs, nom: t.nom, nomImage: t.nomImage, vraies: verites.filter(Boolean).length, distracteurs: codes.filter(Boolean).map((code) => ({ code })) };
    return payload;
};

// ─── Format Saisie de « La figure image » : aire et périmètre de l'image ───

/**
 * Les figures de départ, en cm, de tête : rectangles L × l (L − l ≥ 1,5, pas
 * plus de trois fois plus longs que larges, sinon la figure n'est plus qu'un
 * trait ; jamais 6 × 4, le sacrifié), carrés de côté entier, triangles
 * rectangles (côtés de l'angle droit a et b, hypoténuse h, les trois écrits :
 * l'aire n'utilise pas h).
 */
export const RECTANGLES = [4, 5, 6, 7, 8, 9].flatMap((L) => [2, 2.5, 3, 3.5, 4, 5]
    .filter((l) => L - l >= 1.5 && L <= 3 * l && !(L === 6 && l === 4)).map((l) => ({ L, l })));
export const CARRES = [3, 4, 5, 6, 7, 8, 9];
export const TRIANGLES = [[3, 4, 5], [6, 8, 10], [9, 12, 15], [4.5, 6, 7.5], [8, 15, 17], [12, 16, 20], [1.5, 2, 2.5]];

/** Un nombre de tête écrit à la française (au plus deux décimales). */
const ecrire = (x) => fr(Math.round(x * 100) / 100);

const genAire = () => {
    const forme = randomChoice(['rectangle', 'rectangle', 'carre', 'triangle']);
    const surAire = randInt(0, 1) === 0;
    let poly; let cotes; let droits; let valeur; let nature; let natureImage; let dimensions;
    if (forme === 'rectangle') {
        const { L, l } = randomChoice(RECTANGLES);
        poly = [[0, 0], [L, 0], [L, l], [0, l]];
        cotes = [{ i: 0, texte: `${fr(L)} cm` }, { i: 1, texte: `${fr(l)} cm` }];
        droits = [0, 1, 2, 3];
        valeur = surAire ? L * l : 2 * (L + l);
        nature = 'du rectangle'; natureImage = 'quadrilatère'; dimensions = [L, l];
    } else if (forme === 'carre') {
        const c = randomChoice(CARRES);
        poly = [[0, 0], [c, 0], [c, c], [0, c]];
        cotes = [{ i: 0, texte: `${c} cm` }];
        droits = [0, 1, 2, 3];
        valeur = surAire ? c * c : 4 * c;
        nature = 'du carré'; natureImage = 'quadrilatère'; dimensions = [c];
    } else {
        const [a, b, h] = randomChoice(TRIANGLES);
        const [p, q] = randInt(0, 1) === 0 ? [a, b] : [b, a];
        poly = [[0, 0], [p, 0], [0, q]];
        cotes = shuffle([{ i: 0, texte: `${fr(p)} cm` }, { i: 1, texte: `${fr(h)} cm` }, { i: 2, texte: `${fr(q)} cm` }]);
        droits = [0];
        valeur = surAire ? (a * b) / 2 : a + b + h;
        nature = 'du triangle'; natureImage = 'triangle'; dimensions = [a, b, h];
    }
    poly = tourner(poly, randomChoice([0, 0, randInt(-25, -10), randInt(10, 25)]));
    const noms = pickLettresSains(POOL_LETTRES, poly.length); const nomsImage = noms.map((x) => `${x}'`);
    const nom = noms.join(''); const nomImage = nomsImage.join('');
    const donnee = forme === 'triangle' ? `${nature} ${tex(nom)}, rectangle en ${tex(noms[0])},` : `${nature} ${tex(nom)}`;
    const texte = `<p>Le ${natureImage} ${tex(nomImage)} est l'image ${donnee} par une translation.</p>`
        + `<p><b>Calcule ${surAire ? 'l\'aire' : 'le périmètre'} du ${natureImage} ${tex(nomImage)}.</b></p>`;
    const svg = svgTranslation({ poly, noms, nomsImage, vecteur: vecteurCoteACote(poly), cotes, droits, aria: `La figure ${nom} avec ses dimensions et son image ${nomImage} par une translation, sans mesure.` });
    const payload = makeSaisie(ecrire(valeur), texte, { ...opts(L_IMAGE), suffixe: surAire ? 'cm²' : 'cm', elements_additionnels: imgElement(svg, 'large') });
    payload._meta.params = { forme, surAire, valeur, dimensions, erreurs: forme === 'triangle' && surAire ? [{ code: 'aire_avec_hypotenuse' }] : [] };
    return payload;
};

// ═══ Contrat distracteurs (référence de revue) ═════════════════════════════

export const REGLES_DISTRACTEURS_QCM = {
    invariants_communs: ['figures exactes (décision prof 24/09) ; lettres saines en KaTeX ; mesures affichées toutes différentes ; nom de l\'image jamais lu dans l\'ordre du nom de départ'],
    image_qcm_unique: 'correspondance_par_les_noms (la mesure du côté ou de l\'angle qui a la même place dans le nom : jamais la bonne, par construction), autre_mesure (une troisième mesure affichée), on_ne_peut_pas_savoir',
    egalites_vrai_faux: 'lignes fausses : correspondance_par_les_noms (le côté ou l\'angle de même place dans le nom de départ), autre_mesure quand les deux se confondent',
    etagere: 'les cartes importées gardent le contrat de leur gen (1086, 1088, 1090) ; aucune n\'est un QCM',
};

// ═══ L'étagère : les cartes importées des automatismes (revue 2026-09-25) ═══

/**
 * Clé préfixée par l'outil → le gen source, sa clé, le nom de carte (sans
 * l'outil : le prof le voit, l'élève doit le trouver) et le format affiché.
 */
const ETAGERE = {
    pythagore_echelle_texte: { generer: genererPythagore, cle: 'echelle_texte', label: 'L\'échelle : la hauteur', format: 'Saisie' },
    pythagore_deux_triangles_texte: { generer: genererPythagore, cle: 'deux_triangles_texte', label: 'Deux triangles', format: 'Saisie' },
    cosinus_echelle_texte: { generer: genererCosinus, cle: 'echelle_texte', label: 'L\'échelle : l\'angle', format: 'Saisie' },
    thales_calcul_texte: { generer: genererThales, cle: 'calcul_texte', label: 'Triangles emboîtés', format: 'Saisie' },
};

/** Le payload de la source, re-badgé 189 : l'attendu, la clé préfixée et le nom de carte ; tout le reste (énoncé, figure, calculatrice, distracteurs) est celui de la source. */
const genererEtagere = (key) => {
    const e = ETAGERE[key];
    const payload = e.generer(e.cle);
    if (payload._meta.generatorKey !== e.cle) throw new Error(`gen_189 étagère : ${key} n'a pas rendu ${e.cle}`);
    payload.attendu = ATTENDU_ID;
    payload._meta.generatorKey = key;
    payload._meta.label = e.label;
    return payload;
};

// ═══ Registre et point d'entrée ════════════════════════════════════════════

const GENERATORS = {
    image_qcm_unique: genImage,
    egalites_vrai_faux: genEgalites,
    aire_texte: genAire,
};

const CLES = [...Object.keys(GENERATORS), ...Object.keys(ETAGERE)];

export const CATEGORIES = [
    {
        id: 'image',
        label: L_IMAGE,
        formatsList: [
            { key: 'image_qcm_unique', label: 'QCM' },
            { key: 'egalites_vrai_faux', label: 'Vrai / Faux' },
            { key: 'aire_texte', label: 'Saisie' },
        ],
    },
    ...Object.entries(ETAGERE).map(([key, e]) => ({ id: key, label: e.label, formatsList: [{ key, label: e.format }] })),
];

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && CLES.includes(typeExercice)) key = typeExercice;
    else if (typeExercice) {
        const matching = CLES.filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(CLES);
    } else key = randomChoice(CLES);
    if (ETAGERE[key]) return genererEtagere(key);
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};

export const _internals = { ETAGERE };
